/**
 * /admin/campaigns/new — wraps the shared CampaignForm with create semantics.
 *
 * Heavy lifting (state, localStorage persistence, timezone display, "Run now")
 * lives in CampaignForm so /edit can reuse it.
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import { CreateCampaignInput, createCampaign } from "../../../api/campaigns";
import CampaignForm from "./CampaignForm";

const CampaignCreate: React.FC = () => {
  const nav = useNavigate();

  async function submit(input: CreateCampaignInput) {
    const res = await createCampaign(input);
    nav(`/admin/campaigns/${res.campaign_id}`);
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-3xl mx-auto py-10 px-6">
        <h1 className="text-3xl font-bold text-gray-800 mb-8">
          New Push Campaign
        </h1>
        <CampaignForm
          mode="create"
          onSubmit={submit}
          onCancel={() => nav("/admin/campaigns")}
          submitLabel="Create draft"
        />
      </div>
    </div>
  );
};

export default CampaignCreate;
